import Advantages from './views/Advantages';
export default Advantages;
